import { render, staticRenderFns } from "./create-project-push-money.vue?vue&type=template&id=3c81e19a&scoped=true&"
import script from "./create-project-push-money.vue?vue&type=script&lang=ts&"
export * from "./create-project-push-money.vue?vue&type=script&lang=ts&"
import style0 from "./create-project-push-money.vue?vue&type=style&index=0&id=3c81e19a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c81e19a",
  null
  
)

export default component.exports